export enum PageState {
  EMAIL = 'email',
  PATIENT_INFO = 'patient-information',
  PAYMENT = 'pay',
}

export enum PatientConsentTypes {
  PRACTICE = 'bookAppointmentConsent',
}

export enum AppointmentConsentTypes {
  ENROLLMENT = 'paymentConsent',
}

export enum ConsentFor {
  PATIENT = 'patient',
  APPOINTMENT = 'appointment',
}

export enum AgeGroup {
  AGE_GROUP = 'client_age_group',
}

export enum Gender {
  MALE = 'Male',
  FEMALE = 'Female',
}

export const unknownGender = 'Unknown'

export enum MinRelationships {
  SELF = 'Self',
  SPOUSE = 'Spouse',
  CHILD = 'Child',
  OTHER = 'Other',
}

export const ChildRelationships = {
  Child: 'Child',
  Grandchild: 'Grandson or Granddaughter',
  Stepchild: 'Stepson or Stepdaughter',
  OtherRelationship: 'Other Relationship',
}

export const CouplesRelationships = {
  Spouse: 'Spouse',
  SignificantOther: 'Significant other',
  OtherAdult: 'Other Adult',
  LifePartner: 'Life Partner',
  OtherRelationship: 'Other Relationship',
}

export const OtherRelationships = {
  Grandparent: 'Grandfather or Grandmother',
  Grandchild: 'Grandson or Granddaughter',
  Stepchild: 'Stepson or Stepdaughter',
  SignificantOther: 'Significant other',
  Mother: 'Mother',
  Father: 'Father',
  OtherAdult: 'Other Adult',
  LifePartner: 'Life Partner',
  OtherRelationship: 'Other Relationship',
}

export const OtherRelationShipsLabel = {
  Grandparent: 'Grandparent',
  Grandchild: 'Grandchild',
  Stepchild: 'Stepchild',
}

export const AllRelationships = {
  Spouse: 'Spouse',
  Child: 'Child',
  ...OtherRelationships,
}

export const appointmentModeValueMapping = {
  Online: 'Video visit',
  'In Person': 'In-person',
}

export enum SlotAvailabilityType {
  ONLINE = 'online',
  INPERSON = 'in_person',
}

export enum CounselingTypeEnum {
  INDIVIDUAL = 'Individual Counseling',
  FAMILY = 'Family Counseling',
  MEDICATION = 'Medication/Psychiatry',
  PSYCHOLOGICAL = 'Psychological Testing & Evaluation',
  COUPLES = 'Couples/Marriage Counseling',
}

export type SalesforcePatientPhoneValidationStatus = {
  phoneNumber: string
  success: boolean
}

export const slotAvailabilityEnumMapping = {
  online: SlotAvailabilityType.ONLINE,
  in_person: SlotAvailabilityType.INPERSON,
}

export const slotAvailabilityLabels = {
  online: 'Video visit',
  in_person: 'In-person',
}

export const paymentCardDetailsInitialValues: PaymentCardDetails = {
  paymentCardNumber: '',
  paymentCardExpiry: '',
  paymentCardCVC: '',
}

export const paymentDetailsFormInitialState: PaymentDetails = {
  firstName: '',
  lastName: '',
  address: {
    line1: '',
    line2: '',
    city: '',
    state: '',
    country: '',
    zipcode: '',
  },
}

export const paymentFormInitialState: SupportConsentValues = {
  appointmentConsents: [
    {
      consentType: AppointmentConsentTypes.ENROLLMENT,
      consentRequestedOn: '',
      consentProvidedOn: '',
      isConsentProvided: false,
      rawResponse: '',
      source: '',
    },
  ],
}

export const authorizationDetailsInitialState: AuthorizationDetails = {
  authorizationFormData: {
    personalInformation: {
      gender: '',
      memberId: '',
    },
    referralInformation: {
      referringProviderEhrId: null,
      referralReason: '',
      effectiveDate: '',
      expirationDate: '',
      insuranceCarrier: null,
    },
    authorizationInformation: {
      authorizationNumber: '',
      authorizationDescription: '',
    },
  },
}

export const NAME_REG = /^[a-zA-Z ]{1,50}$/
export const EMAIL_REG = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
export const PHONE_NUMBER_REG = /^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/
export const CHARACTER_REG = /^[aA-zZ\s]+$/
export const NUMBER_REG = /^[0-9\b]+$/
export const MEMBER_ID_REG = /^[a-zA-Z0-9]*$/
export const NOT_ALPHABET_REG = /[^A-Za-z]/g
export const DECIMAL_NUMBER_REG = /^\d+(\.\d+)?$/
export const SIX_DIGIT_OTP = /^\d{6}$/

export const bookingInsuranceErrors = {
  INSURANCE_DOES_NOT_MATCH_WITH_PATIENT:
    'Selected insurance details should be same as primary patient details',
}

export const addressKeysToCheck = [
  'line1',
  'city',
  'state',
  'country',
  'postal_code',
]

export enum PaymentStatus {
  SUCCEEDED = 'succeeded',
  FAILED = 'failed',
  REFUNDED = 'refunded',
}

export enum AmdPayFormFieldId {
  CARD_NUMBER = 'card-number',
  CARD_EXP = 'card-expiration',
  CARD_CVV = 'card-cvv',
}

export enum AmdPayCardStatus {
  NEW = 'new',
  EXISTING = 'existing',
}

export enum BookingFailureErrorMsg {
  PAGE_SUBMISSION_ERROR = 'Failure occured while page submission',
  INSURANCE_SUBMISSION_ERROR = 'Failure occured while insurance submission',
  FETCHING_PATIENT_DATA_ERROR = 'Failure occured while fetching Patient data',
  FETCHING_PROVIDER_DATA_ERROR = 'Failure occured while fetching Provider data',
  FETCHING_B2B_USER_DATA_ERROR = 'Failure occured while fetching B2B User data',
  FETCHING_USER_BOOKING_DATA_ERROR = 'Failure occured while fetching User`s all booking related data',
  CROSS_STATE_BOOKING_ERROR = 'Failure occured on patient page for cross-state booking',
}

export enum BookingButtonLocation {
  TOP_NAVIGATION_BAR = 'Top Navigation bar',
  FOOTER = 'Footer',
  MOBILE_STICKY_CTA_BAR = 'Mobile sticky CTA bar',
}

export const RESPONSIBLE_PARTY_CHECKLIST = [
  'All responsible parties MUST be 18 years +',
  'Minors MUST have a parent / legal guardian listed as the responsible party',
]

export const EMAIL_CREATE_ACTIONS_LIST_DEFAULT = [
  'This person will be the ThriveWeb account holder',
  ...RESPONSIBLE_PARTY_CHECKLIST,
]

export const EMAIL_CREATE_ACTIONS_LIST_SUPPORT = [
  'This person will be the online account holder at Thriveworks.com, where they can manage their appointments',
  ...RESPONSIBLE_PARTY_CHECKLIST,
]

export enum PatientGender {
  MALE = 'Male',
  FEMALE = 'Female',
}

export enum ReferralPlanStatus {
  TALK_THERAPY = 'Talk Therapy',
  PSYCHIATRY = 'Psychiatry / Medication Management',
  FAMILY_THERAPY = 'Family Therapy',
  COUPLES_THERAPY = 'Couples Therapy',
}

export const ReferralPlanTherapyTypeAbbreviations = {
  [ReferralPlanStatus.TALK_THERAPY]: 'TT',
  [ReferralPlanStatus.PSYCHIATRY]: 'MM',
  [ReferralPlanStatus.FAMILY_THERAPY]: 'FT',
  [ReferralPlanStatus.COUPLES_THERAPY]: 'CT',
}

export const patientGenderOptions: SelectItem[] = [
  {
    label: PatientGender.MALE,
    value: PatientGender.MALE,
  },
  {
    label: PatientGender.FEMALE,
    value: PatientGender.FEMALE,
  },
]

export const referralPlanStatusOptions: SelectItem[] = [
  {
    label: ReferralPlanStatus.TALK_THERAPY,
    value: ReferralPlanStatus.TALK_THERAPY,
  },
  {
    label: ReferralPlanStatus.PSYCHIATRY,
    value: ReferralPlanStatus.PSYCHIATRY,
  },
  {
    label: ReferralPlanStatus.FAMILY_THERAPY,
    value: ReferralPlanStatus.FAMILY_THERAPY,
  },
  {
    label: ReferralPlanStatus.COUPLES_THERAPY,
    value: ReferralPlanStatus.COUPLES_THERAPY,
  },
]

export const bookingErrorMessages = {
  AMD_ERROR_SUPPORT:
    'Unable to book - AMDPay Error. Something went wrong when trying to book appointment. Please try again. If you continue to receive an error, notify your Supervisor.',
  AMD_ERROR_USER:
    'Something went wrong when trying to book appointment. Please try again or call us for help at',
  NO_OPEN_SLOT_USER:
    'The clinician is not accepting bookings at the moment. Please try again at a later stage.',
  NO_OPEN_SLOT_SUPPORT:
    'There are no remaining slots for this provider at this time. Please find a different provider or contact your supervisor.',
  SOMETHING_WENT_WRONG:
    'Something went wrong when trying to book appointment. Please try again.',
}

export const RESTRICTED_STIMULANT_STATES = ['OH', 'GA', 'AR', 'TX']
export const ALLOWED_STIMULANT_STATES = [
  'MI',
  'PA',
  'MA',
  'VA',
  'NJ',
  'FL',
  'AZ',
  'MD',
  'DC', // Washington DC is not a state but in our system we have few practices which have DC mentioned in the state and have the address in DC
  'NC',
  'ME',
  'IL',
  'DE',
  'CA',
  'SC',
  'CT',
  'CO',
  'IN',
  'LA',
  'WA',
  'NH',
]

export const maxFetchAuthorizationsApiCallCounter = 5
export const delayFetchAuthorizationsApiCall = 2000

export const bookAppointmentButtonId = 'book-appointment-button'
